import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      await fetch('https://readdy.ai/api/form/d62ccqs3ij519rauvnb0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(
          // FormData entries are iterable; convert to plain object safely
          Object.fromEntries(formData.entries() as Iterable<[string, string]>)
        ).toString(),
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error('送信エラー:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main className="max-w-3xl mx-auto px-4 py-16">
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-3xl text-green-600"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              お問い合わせを受け付けました
            </h1>
            <p className="text-gray-600 mb-8">
              お問い合わせいただきありがとうございます。<br />
              内容を確認の上、担当者より折り返しご連絡いたします。
            </p>
            <a
              href="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-cyan-500 text-white font-medium rounded-lg hover:bg-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              トップページに戻る
            </a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">お問い合わせ</h1>
          <p className="text-gray-600">
            カオナビに関するご質問・ご相談は、下記フォームよりお気軽にお問い合わせください。
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-8 md:p-10">
          <form
            id="contact-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="space-y-6"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  会社名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="company"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="株式会社〇〇"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  部署名
                </label>
                <input
                  type="text"
                  name="department"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="人事部"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  お名前 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="山田 太郎"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  役職
                </label>
                <input
                  type="text"
                  name="position"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="部長"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="example@company.co.jp"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電話番号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm"
                  placeholder="03-1234-5678"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                お問い合わせ種別 <span className="text-red-500">*</span>
              </label>
              <select
                name="inquiry_type"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm cursor-pointer"
              >
                <option value="">選択してください</option>
                <option value="サービスについて">サービスについて</option>
                <option value="料金について">料金について</option>
                <option value="導入について">導入について</option>
                <option value="デモ・トライアルについて">デモ・トライアルについて</option>
                <option value="その他">その他</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                お問い合わせ内容 <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                required
                rows={6}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 outline-none transition-colors text-sm resize-none"
                placeholder="お問い合わせ内容をご記入ください（500文字以内）"
              ></textarea>
            </div>

            <div className="bg-gray-50 rounded-lg p-4">
              <label className="flex items-start cursor-pointer">
                <input
                  type="checkbox"
                  name="privacy_agreement"
                  required
                  className="mt-1 mr-3 w-4 h-4 text-cyan-500 border-gray-300 rounded focus:ring-cyan-500 cursor-pointer"
                />
                <span className="text-sm text-gray-600">
                  <a href="#" className="text-cyan-500 hover:underline cursor-pointer">
                    プライバシーポリシー
                  </a>
                  に同意の上、送信してください。
                </span>
              </label>
            </div>

            <div className="text-center pt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex items-center justify-center px-12 py-4 bg-cyan-500 text-white font-medium rounded-lg hover:bg-cyan-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    送信中...
                  </>
                ) : (
                  '送信する'
                )}
              </button>
            </div>
          </form>
        </div>

        <div className="mt-10 bg-white rounded-lg shadow-sm p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-6">お電話でのお問い合わせ</h2>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div>
              <p className="text-2xl font-bold text-cyan-500 mb-2">
                <i className="ri-phone-line mr-2"></i>
                0120-XXX-XXX
              </p>
              <p className="text-sm text-gray-600">
                受付時間：平日 9:00〜18:00（土日祝日を除く）
              </p>
            </div>
            <div className="mt-4 md:mt-0">
              <p className="text-sm text-gray-500">
                お急ぎの場合はお電話にてお問い合わせください。
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
